import * as Highcharts from "highcharts/highstock";
import $ from "jquery";
import moment from "moment";
import "element-dataset";
import { runInThisContext } from "vm";

const BASE_Y = 100;

// Just a lil shorthand function
var mk = (type) => document.createElement(type);

export class GraphModule {
    constructor() {
        this.chartSelector = ".graph__container";
        this.tableSelector = ".graph__table";
        this.divSelector = ".graph";
        this.comparisonDropdownSelector = "#graph__comparison__index";
        this.$graphLoader = $(".graph__loader");
        this.$graphPageLoader = $(".graph-page-loader");

        this.chart = null;
        this.locale = null;

        this.indexData = {};
        this.chartData = {};

        this.extremes = null;
        this.comparisonObject = null;
        this.comparisonData = null;

        this.mainFileChartObject = null;
        
        this.kpiTimeFormat = "MMM YYYY";
        this.kpiMapping = [
            ".sharpe_ratio",
            ".total_return",
            ".average_annual_return",
            ".maximum_drawdown",
            ".standard_deviation"
        ];

        this.CSVURL = "";
    }

    init() {
        var $graph = $(this.divSelector);

        if (!$graph.length) { return; }
        
        this.CSVURL  = $graph.data('csv-file');

        moment.locale($graph.data('locale'));

        this.load();

        $(".graph__tabs a:first-child").on("click", $.proxy(this.showChart, this));
        $(".graph__tabs a:last-child").on("click", $.proxy(this.showTable, this));
        $(this.comparisonDropdownSelector).on("change", $.proxy(this.changeComparison, this));

        this.triggerInitialTableView();
    }

    triggerInitialTableView() {
        if ($("[data-initital-render='table']").length) {
            $(".graph__tabs a:last-child").trigger('click');
        }
    }

    processData(data, isComparison) {
        // Make sure every chosen span starts with a base value as defined above
        var lastValue = BASE_Y;
        var dataCopy = data.slice(0);
        var first = true;
        var returnData = [];

        if (!isComparison) {
            returnData = dataCopy.map(row => {
                row = row.slice(0);
                if(row[1] == 0 || first) {
                    row[1] = lastValue;
                    first = false;
                } 
                else
                    row[1] = lastValue = lastValue + (lastValue*row[1]);
                
                return row;
            });
        }

        if (isComparison) {
            returnData = data.map(row => {
                row = row.slice(0);
                row[1] = BASE_Y + 100 * row[1];

                return row;
            });
        }

        return returnData;
    }

    updateKPIData(data, isComparison) {
        isComparison = isComparison !== undefined && isComparison;
        /* offset by one, rounding up to next full month
        * (the timestamps are generally the final days of the month, this way it becomes a bit more "correct")
        */
        var displayDate = isComparison ? this.mainFileChartObject[1][0] : data[1][0];
        var fromDate = isComparison ? this.mainFileChartObject[0][0] : data[0][0];
        var toDate = isComparison ? this.mainFileChartObject[this.mainFileChartObject.length-1][0] : data[data.length-1][0];

        var referenceArray = isComparison ? this.comparisonData : this.indexData;

        if(referenceArray === null)
            return;

        var dataArray = referenceArray[fromDate + "-" + toDate];

        var kpiClass = isComparison ? ".strategy_value_comparison" : ".strategy_value";
        var labelClass = isComparison ? ".strategy__kpis.comparison .strategy__time_span" : ".strategy__kpis:not(.comparison) .strategy__time_span";

        $(labelClass).text(moment(displayDate).format(this.kpiTimeFormat)+" - "+moment(toDate).format(this.kpiTimeFormat));

        if (dataArray == null) {
            $(kpiClass).text("-");
        } else {
            for(var i = 0; i < dataArray.length; i++) {
                var setValue = parseFloat(dataArray[i]); /* parseFloat(dataArray[i].replace(",",".")); */ 
                if (setValue == 0)
                    setValue = "-";
                else if (this.kpiMapping[i] == ".sharpe_ratio")
                    setValue = setValue.toFixed(2);
                else
                    setValue = (setValue * 100).toFixed(2) + "%";
    
                $(kpiClass+this.kpiMapping[i]).text(setValue);
            }
        }
        
    }

    processTabEvent(e) {
        e.preventDefault();
        $(".graph__tabs a.active").removeClass("active");
        $(e.currentTarget).addClass("active");
    }

    showTable(e) {
        this.processTabEvent(e);
        
        $(this.chartSelector).hide();
        $(this.tableSelector).show();
    }

    showChart(e) {
        this.processTabEvent(e);
        
        $(this.chartSelector).show();
        $(this.tableSelector).hide();
    }

    renderTable(data) {
        var table = mk("table");

        var thead = mk("thead");
        var tbody = mk("tbody");
        var tr = mk("tr");
        for(var i = 0; i < 14; i++){
            var th = mk('th');
            var header = "";
            if(i == 13)
                th.innerText = "YTD";
            else if(i != 0)
                th.innerText = moment([1,i-1,1]).format("MMM");

            tr.appendChild(th);
        }
        thead.appendChild(tr);
        table.appendChild(thead);

        for(var key in data)
        {
            var tr = mk('tr');

            var th = mk('th');
            th.innerText = key;

            tr.appendChild(th);
            var ytd = 0;
            for(var i = 0; i < 13; i++)
            {
                var th = mk("th");
                var point = data[key][i+1];
                if(i == 12)
                    th.innerText = ((ytd - 1) * 100).toFixed(2)+"%";
                else if(point !== undefined)
                {
                    if (ytd != 0)
                        ytd *= (point + 1);
                    else
                        ytd = (point + 1);

                    th.innerText = (point*100).toFixed(2)+"%";
                }

                tr.appendChild(th);
            }

            tbody.appendChild(tr);
        }

        table.appendChild(tbody);

        $(this.tableSelector).append(table);

    }

    parseComparisonForChart(data) {
        // get start and end date from mainfile
        var fromDate = this.mainFileChartObject[0][0];
        var toDate = this.mainFileChartObject[this.mainFileChartObject.length-1][0];

        const existingData = {}; // stores handled entries timestamps

        let returnData = [];

        for (let key in data) {
            const items = key.split('-');

            if (items.length !== 2) {
                console.error('Mismatch when splitting comparison date.');
                continue;
            }

            const startStamp = items[0];
            const endStamp = items[1];

            /**
             * When loop passes fromdate we are no longer within correct datespan
             * Break out of loop
             */
            if (startStamp > fromDate) {
                break;
            }

            if (startStamp >= fromDate && endStamp <= toDate) {
                if (existingData[endStamp]) {
                    continue;
                }

                existingData[endStamp] = true;
                
                var values = data[key];
                const value = parseFloat(values[1]); // total return
                
                returnData.push([parseInt(endStamp), value]);
            }
            
        }

        // add initial item at start with startdate with value 0
        returnData.unshift([fromDate, 0]);

        return returnData;
    }

    parseChartCSV(csv) {
        var firstDate;
        var tableData = {};
    
        var data = csv.split("\n").map(row => {
            var col = row.split(";");

            // Ignore possible last part which might be a blank string 
            if(col.length == 1)
                return;

            if(firstDate == null)
                firstDate = moment(col[0]).valueOf();

            var value = parseFloat(col[2]); /* parseFloat(col[2].replace(",",".")) */

            var timeObject = moment(col[1]);

            var y = timeObject.format('YYYY').toString();

            var m = timeObject.format('M');
            if(tableData[y] === undefined) {
                var yearArray = {};
                yearArray[m] = value;
                tableData[y] = yearArray
            }
            else
                tableData[y][m] = value;
                
            return [timeObject.valueOf(), value]
        }).filter(v => v !== undefined);

        data.unshift([firstDate, 0]);

        return [data, tableData];
    }

    parseFullCSV(csv) {
        var data = {};
        csv.split("\n").splice(1).map(row => {
            var col = row.split(";");
            // Ignore possible last part which might be a blank string 
            if(col.length == 1)
                return;

            /*var key = 
                moment(col[0]).valueOf().toString()
                + '-'
                + moment(col[1]).valueOf().toString();*/

            var key = 
                moment(col[0]).valueOf()
                + '-'
                + moment(col[1]).valueOf();

            data[key] = col.splice(2);
        });

        return data;
    }

    load(full) {
        full = full !== undefined && full;
        var that = this;
        if(full) {
            $.get(this.CSVURL, function (csv) {
                that.indexData = that.parseFullCSV(csv);
                that.updateKPIData(that.chartData);

                that.hidePageGraphLoader();
                // TODO edge case but make sure the application of the full data respects possibly set extremes
            });
        }
        else
        {
            $.get(this.chartCSVURLFromFullURL(this.CSVURL), function (csv) {
                var [chartObject, tableArray] = that.parseChartCSV(csv);

                that.mainFileChartObject = chartObject;
                that.configureChart(chartObject);
                that.renderTable(tableArray);

                that.load(true);
            });
        }
    }

    loadComparison(file, label) {
        var that = this;

        that.showGraphLoader();

        $.get(file, function (csv) {
            that.comparisonData = that.parseFullCSV(csv);
            var chartObject = that.parseComparisonForChart(that.comparisonData);

            that.comparisonObject = chartObject;
            
            that.chart.series[1].update({name: label});

            if (that.extremes != null) {
                that.updateChartSeries(that.comparisonObject,that.extremes, 1, true);
            } else {
                that.chart.series[1].setData(that.processData(that.comparisonObject, true), true);
            }

            that.updateKPIData(that.comparisonObject, true);

            $('.comparison_index_title').text(label);
            $('.strategy__kpis.comparison').addClass('active');

            that.hideGraphLoader();
        });
    }

    updateChartSeries(dataObject, extremes, seriesNum, isComparison = false) {
        var setData = dataObject.filter(row => {
            return (extremes.min <= row[0] && extremes.max >= row[0]);    
        });

        this.chart.series[seriesNum].setData(this.processData(setData, isComparison), true);
        this.updateKPIData(setData, seriesNum == 1);
    }

    changeComparison(event) {
        var label = event.currentTarget.previousElementSibling;
        var index = event.currentTarget.value;
        var indexName = $(event.currentTarget).find('option:selected').text();
        label.innerText = indexName;
        this.loadComparison(index, indexName);
    }

    configureChart(chartObject) {
        var data = this.processData(chartObject);
        this.chartData = chartObject;
        var element = $(this.chartSelector).get()[0];

        // Piggyback off of moments built in locale support
        var months = [];
        var shortMonths = [];
        for(var i = 0; i < 12; i++) {
            var t = moment([1990,i,1]);
            shortMonths.push(t.format("MMM"));
            months.push(t.format("MMMM"));
        }
        Highcharts.setOptions({
            lang: {
                months: months,
                shortMonths: shortMonths
            }
        })

        var legendLabelStyle = {
            color: "#000",
            fontWeight: 600,
            fontFamily: "myriad-pro-condensed",
            fontSize: "18px",
            textTransform: "uppercase"
        };
        var that = this;
        this.chart = Highcharts.stockChart(element, {
            chart: {
                animation: !1,
                spacingTop: 20,
                style: {
                    fontFamily: "myriad-pro-condensed",
                }
            },
            credits: {
                enabled: false
            },
            series: [{
                name: element.dataset.title,
                data: data,
                color: "#004B86",
                lineWidth: 1.5,
                states: {
                    hover: {
                        lineWidth: 1.5
                    }
                }
            },
            {
                data: [],
                color: "#D4451E",
                lineWidth: 1.5,
                states: {
                    hover: {
                        lineWidth: 1.5
                    }
                }
            }],
            rangeSelector: {
                buttons: [],
                inputEnabled: false,
                allButtonsEnabled: false,
                enabled: false
            },
            tooltip: {
                animation: true,
                pointFormat: '<span style="color:{series.color}; font-weight: 600; text-transform: uppercase">{series.name}</span>: <b>{point.y}</b><br/>',
                valueDecimals: 2,
                formatter: function() {
                    var direction = "up";

                    if (this.point.index == 0)
                        direction = "";
                    else {
                        var prevValue = this.series.yData[this.point.index-1];
                        if (this.point.y < prevValue)
                            direction = "down";
                        else if (this.point.y == prevValue)
                            direction = "";
                    }
                    
                    return '<div class="chart_tooltip">'+
                    '<div style="background:' + this.series.color + '" class="chart_tooltip__value">' + this.point.y.toFixed(2) + '</div>' +
                    '<div class="chart_tooltip__name ' + direction + '" style="color:' + this.series.color + ';"><span class="arrow_icon"></span>' + this.series.name + '</div>' +
                    '<div class="chart_tooltip__date">' + moment(this.point.x).format("LL") + '</div>' +
                    '</div>';

                },
                split: false,
                backgroundColor: "#fff",
                borderColor: "gray",
                style: {
                    fontSize: "18px",
                },
                useHTML: true,
                dateTimeLabelFormats: {
                    millisecond: '%d %b %Y %H:%M',
                    second: '%d %b %Y %H:%M',
                    minute: '%d %b %Y %H:%M',
                    hour: '%d %b %Y %H:%M',
                    month: 'b %Y',
                    day: 'b %Y',
                    week: 'b %Y',
                    year: 'b %Y'
                },
                shape: "square",
                shadow: false,
                borderWidth: 0,
                backgroundColor: "rgba(0,0,0,0)"
            },
            navigator: {
                adaptToUpdatedData: !1,
                maskFill: "rgba(56, 136, 216, 0.2)",
                outlineColor: "#rgba(0,0,0,0)"
            },
            xAxis: {
                tickWidth: 0,
                labels: {
                    style: legendLabelStyle
                },
                events: {
                    afterSetExtremes: (e) => {
                        this.extremes = e;

                        this.updateChartSeries(chartObject,e, 0);

                        if (this.comparisonObject != null) {
                            this.updateChartSeries(this.comparisonObject,e, 1, true);
                        }
                    }
                }
            },
            yAxis: {
                showLastLabel: true,
                opposite: false,
                gridLineColor: "#ccc",
                tickLength: 1,
                labels: {
                    y: 5,
                    style: legendLabelStyle
                }
            },
            scrollbar: {
                enabled: true
            }
        });
    }

    /* HELPERS */

    chartCSVURLFromFullURL(url) {
        var parts = url.split("/");
        var filename = parts[parts.length-1]; 
        var folder = parts.slice(0, parts.length-1).join("/");
        return folder + "/chart_" + filename;
    }

    showGraphLoader() {
        this.$graphLoader.addClass('active');
    }

    hideGraphLoader() {
        this.$graphLoader.removeClass('active');
    }

    hidePageGraphLoader() {
        this.$graphPageLoader.removeClass('active');
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/GraphModule.js